import i18n from "../i18n";

const DeliveryTrackingStatuses = {
  0: {
    name: i18n.global.t("deliveryTrackingStatuses.waiting"),
    color: "badge-outline",
    id: 0,
    icon: "tir",
  },
  1: {
    name: i18n.global.t("deliveryTrackingStatuses.created"),
    color: "bg-info text-body",
    id: 1,
    icon: "box-add",
  },
  2: {
    name: i18n.global.t("deliveryTrackingStatuses.inWarehouse"),
    color: "bg-info text-body",
    id: 2,
    icon: "truck-time",
  },
  3: {
    name: i18n.global.t("deliveryTrackingStatuses.inTransit"),
    color: "bg-primary text-white",
    id: 3,
    icon: "delivery-info",
  },
  4: {
    name: i18n.global.t("deliveryTrackingStatuses.received"),
    color: "bg-warning text-dark",
    id: 4,
    icon: "truck-tick",
  },
  5: {
    name: i18n.global.t("deliveryTrackingStatuses.backToSender"),
    color: "bg-secondary text-white",
    id: 5,
    icon: "truck-remove",
  },
  6: {
    name: i18n.global.t("deliveryTrackingStatuses.returned"),
    color: "bg-success text-white",
    id: 6,
    icon: "trash",
  },
  7: {
    name: i18n.global.t("deliveryTrackingStatuses.onHold"),
    color: "bg-danger text-white",
    id: 7,
    icon: "info-circle",
  },
  8: {
    name: i18n.global.t("deliveryTrackingStatuses.waitForPickup"),
    color: "bg-primary text-white",
    id: 8,
    icon: "shop",
  },
};

export default DeliveryTrackingStatuses;
